import USER_PREF_PRESETS from "./USER_PREF_PRESETS";
import * as RATE_IDS from "../../constants/rates";

const PRESETS_THAT_CAN_BE_NULL = [
  "comparedVehicleId1",
  "comparedVehicleId2",
  "closedExperienceSurveyAt"
];

const ReturnAs = {
  Int: function(val) {
    return isNaN(parseInt(val, 10)) ? 0 : parseInt(val, 10);
  },
  Float: function(val) {
    return isNaN(parseFloat(val)) ? 0 : parseFloat(val);
  },
  String: val => {
    return typeof val === "string" ? val : val.toString();
  }
};

const getUserPref = (key, userPrefs) => {
  if (!userPrefs) return USER_PREF_PRESETS[key];

  const selected = userPrefs[key];
  const preset = USER_PREF_PRESETS[key];
  let type = typeof USER_PREF_PRESETS[key];

  let val;

  if (selected != null) {
    val = selected;
  } else {
    if (preset === null && !PRESETS_THAT_CAN_BE_NULL.includes(key)) {
      console.log("Alarm: Neither state nor preset is defined for " + key);
      return null;
    }
    val = preset;
  }

  if (type === "undefined") {
    console.log("Alarm: Type of " + key + " is undefined");
    return null;
  }

  // Validation to ensure that users who have a no-longer-existing option stored
  // in localStorage are able to use the application correctly.
  // This type of validation should be done for several keys, most likely.
  // A larger effort/refactor is recommended.
  if (["showDetailsForRate", "currentElectricRate"].includes(key)) {
    const rateIds = Object.keys(RATE_IDS).map(k => RATE_IDS[k]);
    if (!rateIds.includes(val)) {
      return USER_PREF_PRESETS[key];
    }
  }

  if (type === "number") {
    return ReturnAs.Int(val);
  }
  if (type === "string") {
    return ReturnAs.String(val);
  }

  return val;
};

export default getUserPref;
